import React from "react"
import {Tabs as MaterialTabs, Tab} from "@mui/material"
import {useLocation, useNavigate} from "react-router-dom"
import styled from "styled-components"

import {OffersTab} from "./CustomerOffers/OffersTab"

import type {Customer} from "@indebted/api"

function Tabs({index, customer}: {index: number; customer: Customer}) {
	const location = useLocation()
	const navigate = useNavigate()

	return (
		<MaterialTabs value={index} variant="scrollable" scrollButtons>
			<AlignedTab label="Overview" onClick={() => navigate(`/customers/${customer.ID}${location.search}`)} />
			<AlignedTab
				label="Cases"
				onClick={() => navigate(`/customers/${customer.ID}/cases${location.search}`)}
				sx={{display: "none"}}
			/>
			<AlignedTab label="Notes" onClick={() => navigate(`/customers/${customer.ID}/notes${location.search}`)} />
			<AlignedTab
				label="Accounts"
				onClick={() => navigate(`/customers/${customer.ID}/accounts${location.search}`)}
			/>
			<AlignedTab
				label="Transactions"
				onClick={() => navigate(`/customers/${customer.ID}/transactions${location.search}`)}
			/>
			<AlignedTab
				label="Payment Plans"
				onClick={() => navigate(`/customers/${customer.ID}/paymentplans${location.search}`)}
			/>
			<AlignedTab
				label="Activities"
				onClick={() => navigate(`/customers/${customer.ID}/activities${location.search}`)}
			/>
			{customer.EnableRocketOffersTab && <OffersTab />}
		</MaterialTabs>
	)
}

const AlignedTab = styled(Tab)`
	min-width: auto;
	max-width: auto;
	padding: 6px 12px;
`

export {Tabs}
